export const BLOCKED_FOR_CRYPTO_COUNTRY = "GB"
